<div class="bl-preview">

  <!-- Cabecera -->
  <div class="bl-preview-head">
    <div class="bl-preview-title">
      <span class="bl-preview-icon" aria-hidden="true">
        <i data-feather="file-text"></i>
      </span>
      <span class="text-truncate" [title]="title">{{ title || label('Cargando archivo…', 'Loading file…') }}</span>
    </div>

    <div class="bl-preview-actions">
      <button type="button" class="bl-icon-btn" (click)="openInPage()" *ngIf="fileId"
        [ngbTooltip]="label('Abrir en Belivpedia', 'Open in Belivpedia')" container="body">
        <i data-feather="external-link"></i>
      </button>
      <button type="button" class="bl-icon-btn" (click)="download()" *ngIf="fileType"
        [ngbTooltip]="'COMMON.ACTIONS.DOWNLOAD' | translate" container="body">
        <i data-feather="download"></i>
      </button>
      <button type="button" class="bl-icon-btn" (click)="modal.dismiss()"
        [ngbTooltip]="'COMMON.BUTTONS.CLOSE' | translate" container="body">
        <i data-feather="x"></i>
      </button>
    </div>
  </div>

  <!-- Cuerpo -->
  <div class="bl-preview-body">

    @if (errorKey) {
      <ngb-alert type="warning" [dismissible]="false">
        <div class="alert-body">{{ errorKey | translate: { type: title } }}</div>
      </ngb-alert>
    }
    @else if (!fileType) {
      <div class="bl-preview-loading">
        <span class="bl-preview-spinner" aria-hidden="true"></span>
        <ngb-progressbar type="primary" [value]="loadingPercent" [showValue]="true" height="8px"></ngb-progressbar>
      </div>
    }
    @else if (fileType === 'pdf') {
      <pdf-viewer [src]="url" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="true"
        [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
        [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false" class="bl-preview-frame"></pdf-viewer>
    }
    @else if (fileType === 'img') {
      <div class="bl-preview-center">
        <img [src]="url" class="img-fluid rounded" [alt]="title" />
      </div>
    }
    @else if (fileType === 'video') {
      <div class="bl-preview-center">
        <video controls class="bl-preview-video">
          <source [src]="url" type="video/mp4" />
        </video>
      </div>
    }
    @else if (fileType === 'txt') {
      <pre class="bl-preview-text">{{ textFileContent }}</pre>
    }
    @else if (fileType === 'html') {
      <iframe [srcdoc]="htmlContent" class="bl-preview-frame" frameborder="0" [title]="title"></iframe>
    }
    @else {
      <!-- Office y demás: el visor embebido no siempre puede, se ofrece descarga -->
      <ngb-alert type="info" [dismissible]="false">
        <div class="alert-body d-flex align-items-center flex-wrap">
          <span class="mr-1">{{ 'BELIVPEDIA.MESSAGES.CANNOT_SEE_FILE' | translate }}</span>
          <button type="button" class="btn btn-sm btn-primary" (click)="download()">
            {{ 'COMMON.ACTIONS.DOWNLOAD' | translate }}
          </button>
        </div>
      </ngb-alert>
      <iframe [src]="url" class="bl-preview-frame" frameborder="0" [title]="title"></iframe>
    }
  </div>
</div>
